import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getTicketByIdApi,
  createTicketApi,
  replyToTicketApi,
  closeTicketApi,
} from '../api/ticket';
import { useToast } from '../context/ToastContext';
import { useAuth }  from '../context/AuthContext';

const is401or403 = (e) => {
  const msg = (e?.message ?? '').toLowerCase();
  return msg.includes('401') || msg.includes('403') ||
         msg.includes('unauthorized') || msg.includes('forbidden');
};

export const useTicket = (ticketId) =>
  useQuery({
    queryKey: ['ticket', ticketId],
    queryFn:  () => getTicketByIdApi(ticketId),
    enabled:  !!ticketId,
  });

export const useCreateTicket = () => {
  const { success, error: showError } = useToast();
  const { logout } = useAuth();

  return useMutation({
    mutationFn: createTicketApi,
    onSuccess: () => {
      success('Ticket submitted. Our team will respond shortly.');
    },
    onError: (e) => {
      if (is401or403(e)) { logout(); return; }
      showError(e?.message || 'Failed to create ticket.');
    },
  });
};

export const useReplyToTicket = () => {
  const queryClient    = useQueryClient();
  const { error: showError } = useToast();
  const { logout }     = useAuth();

  return useMutation({
    mutationFn: replyToTicketApi,
    onSuccess: (_, { ticketId }) => {
      queryClient.invalidateQueries({ queryKey: ['ticket', ticketId] });
    },
    onError: (e) => {
      if (is401or403(e)) { logout(); return; }
      showError(e?.message || 'Failed to send reply.');
    },
  });
};

export const useCloseTicket = () => {
  const queryClient    = useQueryClient();
  const { success, error: showError } = useToast();
  const { logout }     = useAuth();

  return useMutation({
    mutationFn: closeTicketApi,
    onSuccess: (_, ticketId) => {
      success('Ticket closed.');
      queryClient.invalidateQueries({ queryKey: ['ticket', ticketId] });
    },
    onError: (e) => {
      if (is401or403(e)) { logout(); return; }
      showError(e?.message || 'Failed to close ticket.');
    },
  });
};
